import React from 'react';
import './walmartButton.css';

class WalmartButton extends React.Component {
  
  render() {
    const buyNowStyle = {
      display: 'none',
      width: '0px',
      height: '0px'
    };
    const url = (this.props.addToCart) 
      ? "http://c.affil.walmart.com/t/affsdk?l=http://affil.walmart.com/cart/buynow?items=" + this.props.id + "&wmlspartner=PD0Em23B4ME&affsdktrack=trackingid&veh=aff&affs=sdk&affsdktype=html&affsdkcomp=buynowbutton&colorscheme=orange&sizescheme=compact"
      : 'https://www.walmart.com/ip/' + this.props.id;
    return (
      <div className="wm_bnow">
        <a 
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-compact" 
          id="buybutton" 
          href={url}
          data-event-hit="event"
          data-event-category="Clicked Buy Now"
          data-event-action={this.props.name}
          data-event-label={this.props.id}
          data-event-value={this.props.price}
        >
          <img src="//affil.walmart.com/buttons/assets/images/spark.png" alt="Buy Now"/> 
        Buy Now</a>
        <img src="//beacon.walmart.com/vm/ttap.gif?affpublisherid=PD0Em23B4ME&affsdkaction=buynow_button_impression&affsdktrack=trackingid&veh=aff&affs=sdk&affsdktype=html&affsdkcomp=buynowbutton&colorscheme=blue&sizescheme=compact" alt="Walmart Logo" style={buyNowStyle}/>
      </div>
    );
  }
}

export default WalmartButton;


// WEBPACK FOOTER //
// ./src/components/walmart/walmartButton.js